__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@goodt/player";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@goodt-common/api", "0", () => (() => (__webpack_require__(5121))), 1);
			register("@goodt-common/application", "0", () => (() => (__webpack_require__(8784))), 1);
			register("@goodt-common/auth", "0", () => (() => (__webpack_require__(75202))), 1);
			register("@goodt-common/cache", "0", () => (() => (__webpack_require__(39916))), 1);
			register("@goodt-common/data", "0", () => (() => (__webpack_require__(58321))), 1);
			register("@goodt-common/devtools", "0", () => (() => (__webpack_require__(27829))), 1);
			register("@goodt-common/domain", "0", () => (() => (__webpack_require__(24677))), 1);
			register("@goodt-common/dremio-panels", "0", () => (() => (__webpack_require__(15053))), 1);
			register("@goodt-common/dremio", "0", () => (() => (__webpack_require__(18428))), 1);
			register("@goodt-common/error-service", "0", () => (() => (__webpack_require__(24664))), 1);
			register("@goodt-common/errors", "0", () => (() => (__webpack_require__(71511))), 1);
			register("@goodt-common/form", "0", () => (() => (__webpack_require__(97434))), 1);
			register("@goodt-common/graphql", "0", () => (() => (__webpack_require__(20000))), 1);
			register("@goodt-common/infra", "0", () => (() => (__webpack_require__(76773))), 1);
			register("@goodt-common/layers", "0", () => (() => (__webpack_require__(90306))), 1);
			register("@goodt-common/mixins", "0", () => (() => (__webpack_require__(11961))), 1);
			register("@goodt-common/net", "0", () => (() => (__webpack_require__(43128))), 1);
			register("@goodt-common/plugins", "0", () => (() => (__webpack_require__(69308))), 1);
			register("@goodt-common/service-container", "0", () => (() => (__webpack_require__(54120))), 1);
			register("@goodt-common/service-provider", "0", () => (() => (__webpack_require__(49602))), 1);
			register("@goodt-common/services", "0", () => (() => (__webpack_require__(93946))), 1);
			register("@goodt-common/shared", "0", () => (() => (__webpack_require__(90275))), 1);
			register("@goodt-common/utils-number", "0", () => (() => (__webpack_require__(10812))), 1);
			register("@goodt-common/utils", "0", () => (() => (__webpack_require__(32682))), 1);
			register("@goodt-wcore/compat", "0", () => (() => (__webpack_require__(57944))), 1);
			register("@goodt-wcore/components", "0", () => (() => (__webpack_require__(54440))), 1);
			register("@goodt-wcore/core", "0", () => (() => (__webpack_require__(3453))), 1);
			register("@goodt-wcore/elem", "0", () => (() => (__webpack_require__(32993))), 1);
			register("@goodt-wcore/errors", "0", () => (() => (__webpack_require__(39910))), 1);
			register("@goodt-wcore/managers", "0", () => (() => (__webpack_require__(33818))), 1);
			register("@goodt-wcore/panel-ui", "0", () => (() => (__webpack_require__(97703))), 1);
			register("@goodt-wcore/panel", "0", () => (() => (__webpack_require__(65282))), 1);
			register("@goodt-wcore/panels", "0", () => (() => (__webpack_require__(461))), 1);
			register("@goodt-wcore/render", "0", () => (() => (__webpack_require__(10321))), 1);
			register("@goodt-wcore/utils", "0", () => (() => (__webpack_require__(33343))), 1);
			register("dayjs", "0", () => (() => (__webpack_require__(34419))), 1);
			register("goodt-wcore", "0", () => (() => (__webpack_require__(52649))), 1);
			register("goodteditor-ui", "0", () => (() => (__webpack_require__(22817))), 1);
			register("vue", "0", () => (() => (__webpack_require__(51777))), 1);
			register("vuedraggable", "0", () => (() => (__webpack_require__(9026))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};